import PowerSwitches from "../classes/PowerSwitch"

export const powerSwitches = [
  new PowerSwitches({alias:"acometida", svgSrc: "/symbol-assets/Acometida.svg", label: "Label for Type 1"}),
  new PowerSwitches({alias:"arco", svgSrc: "/symbol-assets/Arco.svg", label: "Label for Type 2"}),
  new PowerSwitches({alias:"condensador", svgSrc: "/symbol-assets/Condensador.svg", label: "Label for Type 3"}),
];
